import { createApi } from "../axiosInstance";
import { createShareCapitalApi } from "../shared/shareCapitalApiFactory";
import { createShareTransferApi } from "../shared/shareTransferApiFactory";

const api = createApi("myFPO");

const validateDownloadFormat = (params) => {
  if (params?.format && !["excel", "pdf"].includes(params.format)) {
    throw new Error("Invalid format. strictly allowed 'excel' or 'pdf'");
  }
};

// Members — genuinely FPO-specific, not shared with MyBusiness (see mybusiness.md §3: MyBusiness
// gets its own Membership implementation targeting /company/{id}/member instead).
export const getMember = (fpoId) => api.get(`/fpo/${fpoId}/member`);
export const createMember = (fpoId, data) => api.post(`/fpo/${fpoId}/member`, data);
export const updateMember = (fpoId, id, data) => api.patch(`/fpo/${fpoId}/member/${id}`, data);
export const getMemberById = (fpoId, id) => api.get(`/fpo/${fpoId}/member/${id}`);
export const deleteMemberById = (fpoId, id) => api.delete(`/fpo/${fpoId}/member/${id}`);
export const downloadMemberData = (fpoId, params) => {
  validateDownloadFormat(params);
  return api.get(`/fpo/${fpoId}/member/download`, { params, responseType: "blob" });
};

// Share Capital + Share Transfer — proxied/shared (mybusiness.md §4), sourced from the shared
// factories so MyFPO and MyBusiness run the exact same request logic.
export const {
  getShareCapital,
  getAllMembersShareCapital,
  createShareCapital,
  updateShareCapital,
  getShareCapitalById,
  deleteShareCapitalById,
  downloadShareCapital,
} = createShareCapitalApi(api);

export const {
  getShareTransfer,
  createShareTransfer,
  updateShareTransfer,
  getShareTransferById,
  deleteShareTransferById,
  getShareTransferByMemberId,
  downloadShareTransfer,
} = createShareTransferApi(api);
